<template>
  <div class="ready">
    <p>Next, close any additional broswer tabs (if any) you may have open.</p>
    <img src="../assets/browsers.png" srcset="../assets/browsers.png 1x, ../assets/browsers@2x.png 2x" alt="Instructions">
    <Button text="Next" @click.native="goToReady" />
    <RotateMessage :portrait="portrait" />
  </div>
</template>

<script>
import Button from '@/components/Button.vue'
import RotateMessage from '@/components/RotateMessage.vue'

export default {
  components: {
    Button,
    RotateMessage
  },
  data() {
    return {
      portrait: false
    }
  },
  methods: {
    goToReady() {
      this.$router.push('/ready')
    },
    getOrientation() {
      if(screen.orientation.angle == 0) {
        this.portrait = true
      } else {
        this.portrait = false
      }
    }
  }
}
</script>

<style lang="scss">
.ready {
  height: 100%;
  padding-top: 40px;
  position: relative;
  width: 100%;

  p {
    font-size: 27px;
    width: 80%;
    margin: 0 auto 20px;
    font-weight: bold;
  }

  img {
    margin-bottom: 48px;
  }
}

@media (orientation: landscape) {
  .ready {

    p {
      font-size: 21px;
      line-height: 30px;
      margin: 0 auto 15px;
    }

    img {
      display: block;
      margin: 30px auto;
    }
  }
}
</style>